<template>
    <CModal
      :color="color"
      :show.sync="showModal"
      size="xl"
    >   
    <template #header>
      <CRow style="width: 100%; height: 5px;">
        <CCol md="9">{{title}}</CCol>
        <CCol md="3">
          
        </CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>            
    </template>
      <CRow>
        <CCol md="12">
          <CButton class="crema" size="sm" @click="selectAll()">Seleccionar Todos</CButton>
          <br /><br />
          <CDataTable
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="visits"
            :fields="fields"
            :dark="dark"
          >         
            <template #position="{item}">
              <td class="text-center w50">
                <input type="checkbox" v-model="idsVisits" @change="checkVisits(item)" :value="item.id" :id="'check-'+item.id">
              </td>
            </template>
            <template #date="{item}"><td class="text-center w50" style="font-size: 12px;"><b style="font-size: 12px;">{{item.date | date}}</b></td></template>
            <template #budget="{item}"><td class="text-right w50" style="font-size: 12px;"><b style="font-size: 12px;">{{item.budget | currency}}</b></td></template>
            <template #customer_name="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.customer_name}}</td></template>
            <template #store_name="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.store_name}}</td></template>
            <template #branch_name="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.branch_name}}</td></template>
            <template #freelance_name="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.freelance_name ? item.freelance_name : '-'}}</td></template>
            <template #state="{item}"><td class="text-center w100" style="font-size: 12px;">{{item.state}}</td></template>
            <template #email="{item}">
              <td class="text-center w200" style="font-size: 12px;">
                <template v-if="item.email != ''">
                  {{item.email}}
                </template>
                <template v-else>
                  -
                </template>                  
              </td>
            </template>                    
            <template #actions="{item}">
              <td style="padding: 0px; padding-bottom: 2px;" class="table_actions w150 text-center">                
              </td>
            </template>
          </CDataTable>        
        </CCol>              
      </CRow>      
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="storePaymentVisits" :color="color">Registrar Pago</CButton>
        </template>
    </CModal>
</template>

<script>
import store from '../../store';
import moment from 'moment';
import ws from '../../services/freelancers';

export default {
  name: 'PaymentVisitsModal',
  props: {
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'N°' ,_style:"font-size: 12px;"},
          {key: 'date', label: 'Fecha' ,_style:"font-size: 12px;"},
          {key: 'state', label: 'Zona',_style:"font-size: 12px;"},
          {key: 'customer_name', label: 'Marca',_style:"font-size: 12px;"},
          {key: 'store_name', label: 'Tienda',_style:"font-size: 12px;"},
          {key: 'branch_name', label: 'Sucursal',_style:"font-size: 12px;"},
          {key: 'freelance_name', label: 'Promotor',_style:"font-size: 12px;"},
          {key: 'budget', label: 'Monto',_style:"font-size: 12px;"}
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Pagar Visitas",
      color: "info",
      submitted: false,      
      
      visits: [],      
      idsVisits:[],
      statusCheckAll: false
    }
  },
  mounted: async function() {    
    
  },
  methods: {
    async showPaymentModal (visits) {
      this.visits = visits;

      this.loading();
        this.showModal = true;
        this.color = "info";
        this.title = 'Pagar Visitas';
        this.isEdit = false;
        this.submitted = false;

        this.idsVisits = [];

        this.statusCheckAll = false;

        this.visits.forEach(function callback(visit) {
            visit.checkbox = false;
        });
      this.loaded();

    },
    async storePaymentVisits () {
      this.loading();

      let visits = this.idsVisits;

      if(visits.length > 0){
        let response = await ws.storePaymentVisits({data: visits});

        this.closeModal();

        if(response.type == "success"){
          this.showToast("success", "El pago por las visitas ha sido registrado correctamente.");

          this.$emit("refresh");
        }
        else{
          this.showToast("error", response.message);
        }
      }
      else{
        this.showToast("error", "Debes seleccionar al menos una visita a pagar.");
      }

      this.loaded();          
    },
    checkVisits: function(element){            
      let idx = this.idsVisits.findIndex(c => c.id == element.id);     
      if(idx != -1){
        this.idsVisits.splice(idx, 1);                
        this.statusCheckAll = false;      
      }
    },
    selectAll () {
      if(!this.idsVisits.length > 0){
        this.statusCheckAll = false;  
      }
      this.idsVisits = [];            
      this.statusCheckAll = !this.statusCheckAll
      if(this.statusCheckAll){
        this.visits.forEach(element => {
          this.idsVisits.push(element.id) ;
        });
      }
    },
    closeModal () {
      this.showModal = false;

      this.visits.forEach(function callback(visit) {
          visit.checkbox = false;
      });

      this.idsVisits = [];

      this.submitted = false
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>